module.exports = __webpack_public_path__ + "static/img/logo-gsshop.b823586.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-gsshop.png
// module id = THI1
// module chunks = 0